// 自动加载 src/router/modules 目录下导出的路由模块
// 使用 Vite 的 import.meta.globEager（或 import.meta.glob + eager:true）来在构建时静态引入

type RouteModule = any

export function loadRouteModules(): RouteModule[] {
  // 匹配 modules 目录下所有 tsx/ts 文件（相对于本文件）
  const modules = import.meta.glob('./modules/*.{ts,tsx}', { eager: true }) as Record<string, any>

  const routes: RouteModule[] = []
  Object.keys(modules).forEach((key) => {
    const mod = modules[key]
    // 支持模块使用 default 导出 或 named export 'default'
    if (mod && (mod.default || mod)) {
      const r = mod.default || mod
      // 如果模块导出数组则展开，否则直接 push
      if (Array.isArray(r)) routes.push(...r)
      else routes.push(r)
    }
  })

  // 开发环境下打印已加载模块列表，便于调试（生产环境跳过）
  if (import.meta.env && import.meta.env.DEV) {
    try {
      // eslint-disable-next-line no-console
      console.debug('[loadRouteModules] loaded route modules:', Object.keys(modules))
    } catch (e) {
      // ignore
    }
  }

  return routes
}

export default loadRouteModules
